<template>
  <v-row align-content="center">
    <v-col class="py-0 mx-auto" md="12">
      <v-row>
        <v-col v-show="send" class="white mx-auto" md="6" style="height: 100vh">
          <v-spacer class="py-3"></v-spacer>
          <router-link
            class="font-weight-medium text-decoration-none px-8"
            tabindex="-1"
            color="primary"
            :to="{ name: 'login' }"
          >
            <span><v-icon color="primary"> mdi-arrow-left</v-icon> Kembali Login</span>
          </router-link>
          <v-spacer class="py-8"></v-spacer>
          <v-form class="px-8" @submit.prevent="submit" lazy-validation ref="formku" v-model="valid">
            <div class="mb-4">
              <span class="fs-20 font-weight-medium">Masukkan alamat email Anda dan kami akan mengirimkan kode verifikasi untuk Anda</span>
            </div>
              <v-alert type="error" text dense prominent v-show="response !== null">{{ response }}</v-alert>
              <v-alert type="success" text dense prominent v-show="responsesukses !== null">{{ responsesukses }}</v-alert>
            <v-row>
              <v-col class="pb-0">
                <div class="mb-2 d-md-flex justify-space-between">
                  <div class="font-weight-medium">Email</div>
                  <div
                    class="mt-auto color-disable text-caption"
                    tabindex="-1"
                  >
                    *pastikan anda menulis email yang sesuai
                  </div>
                </div>
                <v-text-field
                  class="rounded-xl"
                  v-model="email"
                  placeholder="email@example.com"
                  :rules="emailRules"
                  required
                  outlined
                  hide-details="auto"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="my-2">
                <v-btn
                  large
                  elevation="0"
                  color="primary"
                  :loading="submiting"
                  block
                  class="rounded-xl"
                  @click="otp()"
                >
                  Lanjut
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-col>
        <v-col v-show="verify" class="py-0 mx-auto" md="12">
          <v-row>
            <v-col class="white mx-auto" md="6" style="height: 100vh">
              <v-spacer class="py-16"></v-spacer>
              <div class="px-8">
                <v-row class="mb-0" justify="center">
                  <v-col sm="6" lg="12" class="text-center">
                    <v-icon class="text-h2 color-strike">mdi-message-processing-outline</v-icon>
                    <div class="text-h5 color-strike">Masukan Kode Verifikasi</div>
                    <p class="text-subtitle-1 color-disable">Kode verifikasi telah dikirim melalui alamat email {{ this.email }}</p>
                  </v-col>
                </v-row>
                <v-form lazy-validation ref="form" v-model="valid" class="mb-2">
                  <v-container>
                    <v-alert type="error" text dense prominent v-show="response !== null">{{ response }}</v-alert>
                    <v-row>
                      <v-col
                        id="kode"
                        cols="12"
                        sm="6"
                        md="7"
                        class="mx-auto py-0"
                      >
                        <!-- <v-text-field
                          v-model="kodeOtp"
                          required
                          :rules="kodeRules"
                        ></v-text-field> -->
                        <v-otp-input
                          class="input-px-0"
                          :disabled="loading"
                          @finish="verifikasi()"
                          length="6"
                          v-model="kodeOtp"
                        ></v-otp-input>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
                <div class="text-subtitle-2 text-center color-disable mb-3">
                  <span v-show="timerMessage">Mohon tunggu dalam <b>{{ totalSeconds | minutesAndSeconds }} detik </b> untuk kirim ulang</span>
                  <span v-show="resend">
                    Tidak menerima kode ? 
                    <v-btn
                      plain
                      color="primary"
                      @click="sendOtp()"
                      class="pa-0 font-weight-bold"
                    >Kirim ulang
                    </v-btn>                
                  </span>
                </div>
                <!-- <v-btn
                  rounded
                  block                  
                  color="primary"
                  class=""
                  @click="reset()"
                >Verfikasi
                </v-btn> -->
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
    <v-snackbar top v-model="snackbar.state" color="primary" outlined>
        <!-- :timeout="timeout" -->
        <div v-html="snackbar.text"></div>
        <template v-slot:action="{ attrs }">
          <v-btn small icon color="error" v-bind="attrs" @click="snackbar.state = false">
            <v-icon>$close</v-icon>
          </v-btn>
        </template>
      </v-snackbar>
  </v-row>
</template>

<script>
export default {
  name: "password-send-email",
  data() {
    return {
      errors: [],
      loading:false,
      valid:true,
      email: "",
      emailRules: [
        v => !!v || 'Email tidak boleh kosong',
        v => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || 'Format email tidak valid',
      ],
      submiting: false,
      response:null,
      responsesukses:null,
      send:true,
      verify:false,
      kodeOtp:"",
      totalSeconds:60,
      timer:{},
      interval:{},
      timerMessage:true,
      resend:false,
      idMember:'',
      kodeRules:[
        (v) => !!v || "Kode OTP tidak boleh kosong",
        (v) => (v && v.length === 6) || "Kode OTP harus 6 karakter",
      ],
      snackbar: {
        state: false,
        text: "",
      },
    };
  },
  filters: {
    minutesAndSeconds(value) {
      var seconds = `${value % 60}`.padStart(2, 0);
      return `${seconds}`;
    },
  },
  methods: {
    submit() {
      // this.$router.push({ name: 'success-send-email'})
    },
    otp() {
      this.submiting = true;
      if (this.$refs.formku.validate()) {
        const data = { user_id: this.email, access_key: process.env.VUE_APP_ACCESS_KEY };

        this.axios
          .put(
            `/auth/v1/member/forgot-password`, data)
          .then((res) => {
            this.submiting = false;
            this.idMember=res.data.data.id;
            // console.log(this.idMember)
            this.verify=true;
            this.send=false;
            this.timer_start();
            this.response = null;
          })
          .catch(() => {
            this.submiting = false;
            this.$refs.formku.reset();
            // console.log(res.data)            
            this.response = "Email Anda tidak valid";
            // console.error(error);
          });
      } else{
        this.submiting=false;
      }     
    },
    timer_start() {
      this.timer = setInterval(() => {
        if (this.totalSeconds === 0) {
          this.totalSeconds = 60;
          clearInterval(this.timer);
          this.timerMessage=false;
          this.resend=true;
        } 
        this.totalSeconds -= 1;
      }, 1000);
    },
    sendOtp(){
      this.timerMessage=true;
      this.resend=false;
      this.timer_start();
      this.otp();
    },
    verifikasi(){
      this.submitingOtp = true;

      const access_key = process.env.VUE_APP_ACCESS_KEY;
      const user_id = this.email;
      const otp = this.kodeOtp;

      this.axios
        .post(
          `/auth/v1/member/verify-otp`,
          { access_key, user_id, otp, type: "forgot_password" },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.submitingOtp = false;
          // let res = response.data;
          if (res.status == 200) {
            this.$router.push({ name: "login" });
          }
        })
        .catch((res) => {
          this.submitting = false;
          this.verify = true;
          this.regis = false;
          this.kodeOtp='';
          if (res.response) {
            this.snackbar.text = res.response.data.message;
            this.snackbar.state = true;
          }
        })
        .finally(() => {
          this.submitingOtp = false;
        });

    }
  },
};
</script>

<style lang="scss">
.input-px-0 input {
  padding-left: 0 !important;
  padding-right: 0 !important;
  text-align: center !important;
  letter-spacing: 0 !important;
  font-size: 30px !important;
}
</style>